import jsesc from "jsesc";
import PropTypes from "prop-types";

// eslint-disable-next-line prettier/prettier, no-empty -- https://github.com/babel/babel/issues/15156
{}
/**
 * A React component that renders an [application/json]{@link https://www.iana.org/assignments/media-types/application/json} script, containing a json serialized representation of the content prop, sanitized for SSR using [jsesc]{@link https://github.com/mathiasbynens/jsesc} (which is a required peer dependency).
 * @memberof module:asos-web-toggle-point-ssr
 * @inner
 * @function
 * @param {object} params parameters
 * @param {string} params.id The id attribute of the json script.
 * @param {string} params.content The name of the prop to inject into the wrapped React component.
 * @returns {external:React.Component} React component to be written to the page on the server.
 * @example
 * return (
 *    <JsonScript id={"script_id"} content={{ key1: "value1", key2: "value2" }} />
 * )
 */
const JsonScript = ({ id, content = null }) => (
  <script
    id={id}
    type="application/json"
    dangerouslySetInnerHTML={{
      __html: jsesc(content, {
        isScriptContext: true,
        json: true
      })
    }}
  />
);

JsonScript.propTypes = {
  id: PropTypes.string.isRequired,
  content: PropTypes.object
};

export default JsonScript;
